module.exports = __webpack_public_path__ + "static/7-ca9f9761400af5fb679c9a7187548ca6.jpg";